import { Component, Input } from '@angular/core';
import {
  EntityType,
  EventType,
  LogRegistry,
  ValidEvents,
} from 'src/app/core/models/history-log';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-log-context',
  templateUrl: './log-context.component.html',
  styleUrls: ['./log-context.component.scss'],
})
export class LogContextComponent {
  @Input() entityType: EntityType;
  @Input() eventType: ValidEvents<EntityType>;
  @Input() context: LogRegistry[EntityType][ValidEvents<EntityType>]['context'];
  @Input() displayCurrency: { code: string; symbol: string };

  readonly EntityType = EntityType;
  readonly EventType = EventType;

  constructor(public sanitizer: DomSanitizer) {}

  formatCurrency(value?: number): string {
    if (value == null) return 'N/A';
    return `${this.displayCurrency?.symbol || '$'}${value.toFixed(2)}`;
  }

  generateContextHTML(context: any) {
    if (
      this.entityType === EntityType.CAMPAIGN &&
      this.eventType === EventType.BUDGET_CHANGES
    ) {
      return `
        Avg days until stockout: ${context?.params?.avg_days_until_stockout} units
        <br>
        Min Threshold: ${context?.params?.min_days_until_stockout_risk} units
        <br>
        Max Threshold: ${context?.params?.max_days_until_stockout_risk} units
      `;
    }

    if (
      this.entityType === EntityType.ITEM &&
      this.eventType === EventType.PRICING_CHANGES_BY_RECOMMENDATION
    ) {
      return `
        Restock Days: ${context?.params?.restock_days} units
        <br>
        Sale Velocity: ${context?.params?.velocity} units
        <br>
        Days Of Inventory: ${context?.params?.days_of_inventory} units
      `;
    }

    return null;
  }
}
